import { createAsyncThunk } from '@reduxjs/toolkit';

export const reconnectSalesChannel = createAsyncThunk(
  'salesChannels/reconnectSalesChannel',
  async ({ salesChannelId }, { extra: { sdk, Logger } }) => {
    try {
      const { data } = await sdk.setup.reconnectSalesChannel({ salesChannelId });
      return { salesChannelId, ...data };
    } catch (error) {
      Logger.error(
        new Error('Reconnect sales channel failed'),
        { error, salesChannelId },
        ['ConnectShopifyChReconnectFailed', { salesChannelId: String(salesChannelId) }],
      );
      throw error;
    }
  },
);
